import { render, staticRenderFns } from "./MyCollectionCompare.vue?vue&type=template&id=6cf514c3&"
import script from "./MyCollectionCompare.vue?vue&type=script&lang=js&"
export * from "./MyCollectionCompare.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports